import { render, staticRenderFns } from "./Answered.vue?vue&type=template&id=0fa934b2"
import script from "./Answered.vue?vue&type=script&lang=js"
export * from "./Answered.vue?vue&type=script&lang=js"
import style0 from "./Answered.vue?vue&type=style&index=0&id=0fa934b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports